import * as Yup from 'yup';

export interface IDirectDocsForm {
  userPhoneNumber: string;
  ownerFullName: string;
  bankAccountNumber: string;
  nationalCardFile: File | null;
  invoiceFile: File | null;
  secondInvoiceFile: File | null;
  livingAddress: string;
  postalCode: string;
}

export const getDirectLoanDocsInitialValues = (
  farmerProfile?: IFarmer_profile,
): IDirectDocsForm => {
  const localUser = localStorage.getItem('user');

  const parsedUser = localUser ? JSON.parse(localUser) : null;

  return {
    userPhoneNumber:
      farmerProfile?.cell_phone ||
      parsedUser?.profile?.supplier_profile?.phone_number ||
      '',

    ownerFullName: '',
    bankAccountNumber: '',
    nationalCardFile: null,
    invoiceFile: null,
    secondInvoiceFile: null,
    livingAddress: '',
    postalCode: '',
  };
};

export const directLoanDocsValidationSchema = Yup.object().shape({
  ownerFullName: Yup.string()
    .min(3, 'نام و نام خانوادگی مالک شماره را وارد کنید')
    .required('نام و نام خانوادگی مالک شماره را وارد کنید'),
  bankAccountNumber: Yup.string()
    .min(10, 'شماره حساب بانکی که قصد دارید از آن وام بگیرید را وارد کنید')
    .required('شماره حساب بانکی که قصد دارید از آن وام بگیرید را وارد کنید'),
  nationalCardFile: Yup.mixed()
    .required('تصویر کارت ملی را بارگذاری کنید')
    .test('fileType', 'فایل با پسوند مجاز بارگذاری کنید', value => {
      if (!value) return false;
      const supportedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      return supportedTypes.includes(value.type);
    })
    .test('fileSize', 'حجم فایل باید کمتر از 3 مگابایت باشد', value => {
      if (!value) return false;
      return value.size <= 3 * 1024 * 1024; // 5MB max
    }),
  invoiceFile: Yup.mixed()
    .required('تصویر پیش پرداخت و تاییده شغلی را بارگذاری کنید.')
    .test('fileType', 'فایل با پسوند مجاز بارگذاری کنید', value => {
      if (!value) return false;
      const supportedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      return supportedTypes.includes(value.type);
    })
    .test('fileSize', 'حجم فایل باید کمتر از 3 مگابایت باشد', value => {
      if (!value) return false;
      return value.size <= 3 * 1024 * 1024;
    }),
  secondInvoiceFile: Yup.mixed()
    .required('تصویر پیش پرداخت و تاییده شغلی را بارگذاری کنید.')
    .test('fileType', 'فایل با پسوند مجاز بارگذاری کنید', value => {
      if (!value) return false;
      const supportedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      return supportedTypes.includes(value.type);
    })
    .test('fileSize', 'حجم فایل باید کمتر از 3 مگابایت باشد', value => {
      if (!value) return false;
      return value.size <= 3 * 1024 * 1024;
    }),
  livingAddress: Yup.string().required('آدرس محل سکونت را وارد کنید'),
  postalCode: Yup.string()
    .min(10, 'کد پستی باید 10 رقم باشد')
    .required('کد پستی را وارد کنید'),
});
